import { Typography } from "@mui/material";
import React from "react";  
import AvailableBatchConclution from './../AvailableBatchConclution/AvailableBatchConclution';
import BatchConclutionHeader from './../BatchConclutionHeader/BatchConclutionHeader';

const BatchConclution = () => {
  document.title = "Physics Admission Batch ~ Physics Of Stupid";
  return (
    <div>
      <BatchConclutionHeader />

      <Typography sx={{ mt: "10px", px: "4px" }} variant="body1" gutterBottom>
       কুফা ২২ এটাই তোমাদের শেষ সুযোগ কুপিয়ে দেওয়ার জন্য 🖊️🔪🖋️
      </Typography>

      <AvailableBatchConclution />
    </div>
  );
};

export default BatchConclution;
